import React from 'react';
import { Link } from 'react-router-dom';

const LegalHeader = () => {
    return (
        <header className="legal-header">
            <div className="legal-header-content">
                <Link to="/" className="legal-logo-link">
                    <img
                        src="/final-logos/badge.png"
                        alt="Ferritico logo"
                        className="legal-logo"
                    />
                    <img
                        src="/final-logos/blue.png"
                        alt="Ferritico wordmark"
                        className="legal-logo"
                    />
                </Link>
                <Link to="/" className="back-to-site">
                    ← Back
                </Link>
            </div>
        </header>
    );
};

export default LegalHeader;
